import { createReducer, on } from '@ngrx/store';

import { FertilizationLegalStandardState } from '../fertilization-legal-standards.models';
import * as LegalStandardActions from './fertilization-legal-standard.actions';

export const fertilizationLegalStandardReducer = createReducer<FertilizationLegalStandardState>(
  {},
  on(
    LegalStandardActions.setFertilizationLegalStandards,
    (state, { fertilizationLegalStandards }) => ({ ...state, fertilizationLegalStandards }),
  ),
  on(LegalStandardActions.setLoggedInEmployee, (state, { employee }) => ({
    ...state,
    loggedInEmployee: employee,
  })),
);
